import React from 'react';
import { Typography } from '@mui/material';
import { Link } from 'react-router-dom';

import { COLORS, ROUTES } from '../../../../../../config/constants';

type SearchArticleProps = {
    number: React.ReactNode;
    category?: React.ReactNode;
    title: React.ReactNode;
    text: React.ReactNode;
    documentId?: string;
};

const SearchArticle = ({ number, category, title, text, documentId }: SearchArticleProps) => (
    <article className='search-article'>
        <Typography variant='body2' sx={{
            width: '32px',
        }}>
            {number}
        </Typography>
        <div className='search-article__text'>
            <Typography variant='body2' sx={{
                color: COLORS.BLACK,
            }}>
                {category}
            </Typography>
            <Typography
                variant='h6'
                component={Link}
                to={documentId ? `${ROUTES.ARTICLE}?documentId=${documentId}` : ROUTES.ARTICLE}
                sx={{
                    color: COLORS.BLUE,
                    marginTop: 2,
                    textDecoration: 'underline',
                    letterSpacing: 0,
                    lineHeight: '28px',
                    display: 'inline-block',
                }}
            >
                {title}
            </Typography>
            <Typography variant='subtitle1' sx={{
                fontWeight: '400',
                letterSpacing: 0,
                lineHeight: '24px',
                marginTop: 2,
            }}>
                {text}
            </Typography>
        </div>
    </article>
);

export default SearchArticle;
